var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { NavBarHeight } from '../constants';
import { FlyoutMenuContainer } from './Container/FlyoutMenuContainer';
import { FlyoutMenuBackdrop } from './Backdrop/FlyoutMenuBackdrop';
import { AnimatePresence, m } from 'framer-motion';
import { useFlyoutVariants } from './config';
export var FlyoutMenu = function (_a) {
    var children = _a.children, _b = _a.opened, opened = _b === void 0 ? false : _b, onClose = _a.onClose, contentKey = _a.contentKey, onMouseEnter = _a.onMouseEnter;
    var variant = useFlyoutVariants({
        initial: {
            y: '-100%'
        },
        animate: {
            y: '0%'
        },
        exit: {
            y: '-100%'
        }
    });
    React.useEffect(function () {
        if (opened) {
            var scrollTop_1 = window.pageYOffset || document.documentElement.scrollTop;
            var scrollLeft_1 = window.pageXOffset || document.documentElement.scrollLeft;
            window.onscroll = function () { return window.scrollTo(scrollLeft_1, scrollTop_1); };
        }
        else {
            window.onscroll = function () { };
        }
        return function () {
            window.onscroll = function () { };
        };
    }, [opened]);
    return (React.createElement("div", { role: "presentation" },
        React.createElement(AnimatePresence, null, opened && (React.createElement(FlyoutMenuBackdrop, { onClose: onClose },
            React.createElement(m.div, __assign({ key: "content" }, variant),
                React.createElement(FlyoutMenuContainer, { contentKey: contentKey, onClose: onClose },
                    React.createElement("div", { onMouseMoveCapture: function (e) {
                            e.stopPropagation();
                            e.preventDefault();
                            if (onMouseEnter)
                                onMouseEnter();
                        }, style: { paddingTop: "calc(32px + ".concat(NavBarHeight, "px)") } }, children))))))));
};
